var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0306 19.4702C5.21736 22.7946 2.65366 27.6328 2.65366 27.6328C2.65366 27.6328 2.17053 28.3508 1.74195 29.7945L1.66402 30.0676C1.65623 30.3875 1.64844 30.6997 1.64844 31.0196C1.64844 42.772 8.59146 52.9011 18.5891 57.5209H18.8307L30.4959 45.8388C22.5009 45.6905 16.3215 39.1199 16.3215 31.0821C16.3215 31.0118 16.3215 30.9338 16.3215 30.8636C16.3215 23.5281 21.7684 17.3944 28.8283 16.4346C25.9841 16.5516 20.3346 17.0979 14.0306 19.4702Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6717 44.3733L19.3477 34.0804L17.3085 32.0474C18.1287 39.5269 23.0649 44.0207 29.6717 44.3733Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5587 16.4346C30.5587 16.4346 30.5351 16.4346 30.4958 16.4346L44.8017 30.4039L59.3433 16.4346H30.5587Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6836 1.64355C15.6263 1.64355 3.24412 12.7916 1.64844 27.1171C1.80488 26.8568 1.92221 26.6807 1.92221 26.6807C1.92221 26.6807 5.02753 21.7039 13.8116 18.2814C22.3923 14.9354 30.6836 15.4101 30.6836 15.4101H59.3433L45.1934 1.64355H30.6836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de12593f015d0c920c88d04590d0ba47.svg";
export { ForwardRef as ReactComponent };